
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-2-product-page/specs",
      function () {
        return require("private-next-pages/stream-2-product-page/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-2-product-page/specs"])
      });
    }
  